<template>
  <span
    class="inline-flex items-center justify-center rounded-full bg-indigo-100 dark:bg-gray-600"
    :class="classes"
  >
    <SpanText
      :size="textSize"
      font="font-medium"
      color="text-indigo-600"
      class="leading-none"
      >{{ initials }}</SpanText
    >
  </span>
</template>

<script setup>
import { computed } from 'vue'
import SpanText from '@/Common/Text/SpanText.vue'
import { getSizeClasses } from './common'

const props = defineProps({
  name: String,
  size: {
    type: String,
    default: 'sm',
  },
})

const initials = computed(() => {
  let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu')

  let initials = [...props.name.matchAll(rgx)] || []

  return (
    (initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')
  ).toUpperCase()
})

const classes = computed(() => getSizeClasses(props.size))

const textSize = computed(() => {
  return {
    xs: 'text-xs',
    sm: 'text-sm',
    md: 'text-md',
    lg: 'text-lg',
    xl: 'text-xl',
    '3xl': 'text-3xl',
  }[props.size]
})
</script>
